<template>
  <div class="coaching-core-data">
    <div class="title-1" style="margin-bottom: 15px">心理辅导核心数据</div>
    <div class="data-list flex-around-center">
      <div
        v-for="(item, index) in dataSource"
        :key="index"
        class="list-item flex-column"
        style="align-items: center"
      >
        <img
          :src="require(`@/assets/imgs/school/monthRecord/${item.icon}.png`)"
          alt=""
          style="width: 48px; height: 48px"
        />
        <div style="margin: 10px 0">{{ item.label }}</div>
        <div>
          <CountAnimation :end-val="Number(item.value)" class="count-bold" />
          <span>{{ index === 0 ? '%' : '次' }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CountAnimation from '@comp/CountAnimation/index.vue'

export default {
  name: 'CoachingCoreData',
  components: { CountAnimation },
  props: {
    dataSource: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {}
  },
}
</script>

<style scoped lang="less">
.coaching-core-data {
  padding: 20px;
  background-color: #eff6ff;
  border-radius: 10px;
  .data-list {
    .list-item {
      .count-bold {
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
}
</style>
